// TODO: Urls will eventually come from an AEM source
// This helper component will be deprecated
import {
  Preview1,
  Preview2,
  Preview3,
  Preview4,
  Preview5,
  Preview6,
  Horizontal1,
  Horizontal2,
  Horizontal3,
  Horizontal4,
  Horizontal5,
  Horizontal6,
  Square1,
  Square2,
  Square3,
  Square4,
  Square5,
  Square6,
  Vertical1,
  Vertical2,
  Vertical3,
  Vertical4,
  Vertical5,
  Vertical6,
} from '../../../assets';

export interface ShareableSection {
  images: {
    altText: string;
    title: string;
    previewUrl: string;
    squareUrl: string;
    horizontalUrl: string;
    verticalUrl: string;
  }[];
}

export const getShareables = (): ShareableSection => ({
  images: [
    {
      title: 'Astronaut',
      altText:
        'A clay astronaut figure floating in front of a crayon-style drawing of a silver and red rocket ship flying in space around the planet Earth',
      previewUrl: Preview1,
      horizontalUrl: Horizontal1,
      verticalUrl: Vertical1,
      squareUrl: Square1,
    },
    {
      title: 'Heart',
      altText:
        'Crayon-style drawing of a red heart with pink, yellow, and purple waves emanating out from the edges of the heart',
      previewUrl: Preview4,
      horizontalUrl: Horizontal4,
      verticalUrl: Vertical4,
      squareUrl: Square4,
    },
    {
      title: 'Light-fight',
      altText:
        "Yellow text on a red background that reads the following: Unextinguishable. Your light is never as bright as when you're in the fight",
      previewUrl: Preview6,
      horizontalUrl: Horizontal6,
      verticalUrl: Vertical6,
      squareUrl: Square6,
    },

    {
      title: 'LoveStJude',
      altText:
        'White handwriting that says I love St. Jude! on a red background with the same text repeating as a pattern',
      previewUrl: Preview5,
      horizontalUrl: Horizontal5,
      verticalUrl: Vertical5,
      squareUrl: Square5,
    },
    {
      title: 'Rocket',
      altText:
        'Paint/crayon style drawing of a rocket ship which says St. Jude on the side flying through space',
      previewUrl: Preview2,
      horizontalUrl: Horizontal2,
      verticalUrl: Vertical2,
      squareUrl: Square2,
    },
    {
      title: ' Rocket-earth',
      altText:
        'A paint/crayon style drawing of a blue rocket ship with purple wings and green engines flying through space with earth in the background',
      previewUrl: Preview3,
      horizontalUrl: Horizontal3,
      verticalUrl: Vertical3,
      squareUrl: Square3,
    },
  ],
});
